var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContato(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_5090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9.80469C20.9315 10.3869 21.6875 11.1418 22.2082 12.0096C22.7289 12.8774 23 13.8344 23 14.8047C23 15.775 22.7289 16.7319 22.2082 17.5998C21.6875 18.4676 20.9315 19.2225 20 19.8047",
    stroke: "#1CC9AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74472 18.586H6.24824C5.91719 18.586 5.59969 18.4532 5.3656 18.2168C5.13151 17.9804 5 17.6598 5 17.3255V12.2838C5 11.9495 5.13151 11.6289 5.3656 11.3926C5.59969 11.1562 5.91719 11.0234 6.24824 11.0234H8.74472L13.1136 5.35147C13.2227 5.13749 13.404 4.96997 13.6247 4.87918C13.8454 4.78839 14.0911 4.78032 14.3172 4.85643C14.5433 4.93254 14.735 5.08781 14.8577 5.29418C14.9803 5.50054 15.0258 5.7444 14.9859 5.98169V23.6277C15.0258 23.865 14.9803 24.1088 14.8577 24.3152C14.735 24.5216 14.5433 24.6768 14.3172 24.7529C14.0911 24.829 13.8454 24.821 13.6247 24.7302C13.404 24.6394 13.2227 24.4719 13.1136 24.2579L8.74472 18.586Z",
    stroke: "#1CC9AE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_5090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.804688)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContato);
export default __webpack_public_path__ + "static/media/contato.cecb88b33777657ccf5ae8b31cfa86e2.svg";
export { ForwardRef as ReactComponent };